$(document).ready(function() {
  $(".slideshow a[href*='#']:not([href='#])").click(function() {
    let target = $(this).attr("href");
    $('html,body').stop().animate({
      scrollTop: $(target).offset().top - 50
    }, 1000);
    event.preventDefault();
  });
  
  $(".pfl-text h3 a[href*='#'], .pfl-text .link2 a[href*='#']").click(function(e){
    $(this).parents('.pfl-item').find('.pfl-thumb').trigger('click');
    e.preventDefault();
  });

  $(".sidebar-filter .sidebar-tags label").click(function(){
    setTimeout(function(){
      location.reload();
    }, 100);
  });

  $('.swatch .swatch-element').click(function(){
    setTimeout(function(){
      var val = $('.swatch-befestigung input[type=radio]:checked').data('value');
      $('.product-img-box').hide();
      $('#'+val+'-images').show();
      $('.slider-for').slick('slickAdd');
      $('.slider-nav').slick('slickAdd');
      $('.slider-for').slick('slickGoTo', 0);
    }, 500);
  });
});



 jQuery(function($) {
    window.VIG = window.VIG || {};
    VIG.VariantChangeCallback = function(){
      $('.slick-initialized').each(function(index,slider){
           $(slider).slick("slickFilter",function(){
            if($(this).css("display")!="none"){
              return true;
            }
          });
      });

       setTimeout(function(){ 
        $('.slider-nav .slick-slide').each(function(index){
        		$(this).attr('data-index', index);
          		$(this).attr('data-slick-index', index);
           		$(this).find('a').attr('data-index', index);
        });
      	$('.product-photo-container.slider-for .slick-slide').each(function(index){
        		$(this).attr('data-index', index);
          		$(this).attr('data-slick-index', index);
        });
        
        $('.slider-nav .slick-slide').first().click(); 
        $('.slider-nav .slick-track').css('transform', 'none');
                           }, 200);
      
    };
    VIG.BeforeVariantChange = function(){
      $('.slick-initialized').each(function(index,slider){
           $(slider).slick("slickUnfilter");
      })
    };
   console.log("Testing");
  });  